<template>
  <div class="grid grid-flow-col auto-cols-fr max-w-screen-xl" role="navigation">
    <div v-for="(column, indexCol) in columns" :key="indexCol" class="mx-4 grid gap-4 content-start" role="list">
      <div v-for="(block, indexBlock) in column.blocks" :key="indexBlock" class="inline-block" role="listitem">
        <NavBlocksLinkSection v-if="block.typeHandle == 'linkSection'" v-bind="block" />
        <NavBlocksImageFeature v-if="block.typeHandle === 'imageFeature'" v-bind="block" />
      </div>
    </div>
  </div>
</template>

<script setup>
import NavBlocksLinkSection from '@/components/layout/header/navBlocks/NavBlocksLinkSection';
import NavBlocksImageFeature from '@/components/layout/header/navBlocks/NavBlocksImageFeature';

const props = defineProps({
  blocks: {
    type: Array,
    default: () => [],
  },
});

const columns = computed(() => {
  const columns = [];
  let currentColumnIndex = 0;
  props.blocks.forEach((block, i) => {
    if (i === 0) {
      columns.push({
        blocks: [block],
      });
    } else if (block.startNewColumn || block.typeHandle === 'imageFeature') {
      columns.push({
        blocks: [block],
      });
      currentColumnIndex++;
    } else {
      columns[currentColumnIndex].blocks.push(block);
    }
  });
  return columns;
});
</script>
